import React, { use, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as loginActions from '../../store/modules/loginSlice';
import { bindActionCreators } from 'redux';
import { showToast } from '../Common/Messages';
import OTPVerificationPanel from './OTPVerificationPanel';
import { useLocation, useNavigate } from 'react-router-dom';

const LoginPanel = (props) => {
    const location = useLocation();
    const history = useNavigate();
    const dispatch = useDispatch();
    const LoginActions = bindActionCreators(loginActions, dispatch);
    const [openOTP, setOpenOTP] = useState(false);
    const [isVerify, setIsVerify] = useState(false);
    const [authCode, setAuthCode] = useState('0');
    const [otpType, setOtpType] = useState('0');
    const [isAutoLogin, setIsAutoLogin] = useState(localStorage.getItem("isAutoLogin") ? JSON.parse(localStorage.getItem("isAutoLogin"))?.isAutoLogin : false);

    const [userInfo, setUserInfo] = useState({
        userId: props.userId,
        userPassword: '',
        showAlert: ''
    });
    useEffect(() => {
    }, []);

    useEffect(() => {
        if (location.state?.loginType === 'cookie') {
            setUserInfo(prev => { return {
                ...prev,
                userId: location.state?.userId ?? '',
                userName: location.state?.userName ?? ''
            }});
            setOtpType(location.state?.otpType ?? '1');
            setOpenOTP(true);
        }
    }, [location.state]);

    useEffect(() => {
        if (isVerify) {
            if (location.state?.loginType !== 'cookie') {
                doLogin({
                    userId: encodeURI(userInfo.userId),
                    userPassword: encodeURI(userInfo.userPassword)  //Http 통신을 통해 입력된 문자열을 전달할 때는 이스케이프 처리를 해주는 것이 좋다.
                });
            }
        }
    }, [isVerify]);

    const handleChange = (e) => {
        //이메일, 비밀번호 칸에 입력한 값으로 저장, but 리렌더링은 제일 마지막에
        setUserInfo(prev => { return {
            ...prev,
            [e.target.name]: e.target.value
        }});
    };

    const onSubmitSignUp = (e) => {
        //회원가입 패널로 넘어가기위한 panel타입을 설정해줌
        props.setPanelType('signUp');
    };

    const onSubmit = async (e) => {
        //로그인 버튼을 눌렀을 때 발생하는 이벤트
        e.preventDefault();
        let userId = userInfo.userId;
        let userPassword = userInfo.userPassword;
        let emailExpression = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        let notice = '';
        if (userId == undefined || userId == null || userId == "") {
            userId = document.getElementsByName('userId')[0].value;
        }
        if (userPassword == undefined || userPassword == null || userPassword == "") {
            userPassword = document.getElementsByName('userPassword')[0].value;
        }
        
        if (userId == "" || userPassword == "") {
            notice = "이메일과 비밀번호를 입력해주세요.";
            showToast('warning', notice);
        }
        else if (emailExpression.test(userId) == false) {
            notice = "잘못된 형식의 이메일 주소입니다. 이메일을 다시 입력해주세요.";
            showToast('warning', notice);
        }
        else {
            const userInfo = {
                userId: encodeURI(userId),
                userPassword: encodeURI(userPassword)  //Http 통신을 통해 입력된 문자열을 전달할 때는 이스케이프 처리를 해주는 것이 좋다.
            };
            setUserInfo(prev => { return { ...prev, showAlert: "" }});
            doLogin(userInfo);
        }
    };
    const doLogin = (userInfo) => {
        fetch('api/Login/Login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({...userInfo, authCode: authCode})
        }).then((response) => response.json())
            .then(async (data) => {
                const info = data.userInformation;
                if (data.status != 'Success Login' && data.status != 'Already Session Exists' && data.status != 'Change Password') {
                    showToast('danger', data.message, 3000);
                } else {
                    const otpType = Number(info.userSendOtpType);
                    if (data.status === 'Success Login' && !isVerify && Number.isInteger(otpType) && otpType >= 0) {
                        if (openOTP) {
                            showToast('warning', '2단계 인증이 완료되지 않았습니다.', 3000);
                        } else {
                            setUserInfo(prev => { 
                                return { 
                                    ...prev, 
                                    userId: info.userId,
                                    userName: info.userName ?? '',
                                }
                            });
                            setOtpType(info.userSendOtpType);
                            setOpenOTP(true)
                        }
                        return;
                    }
                    if (data.status === 'Change Password') {
                        await LoginActions.setResultLogin({
                            userId: info.userId ?? userInfo.userId ?? '',
                            userName: info.userName ?? ''
                        });
                        props.setMessage(data.message);
                        props.setResult(data.status);
                        return;
                    }
                    const result = {
                        userId: info.userId ?? '',
                        userPassword: decodeURI(userInfo.userPassword ?? ''),
                        userName: info.userName ?? '',
                        sessionId: info.sessionID ?? '',
                        companyName: info.companyName ?? '',
                        companySeq: info.companySeq ?? '',
                        companyType: info.companyType ?? '',
                        devType: info.devType ?? '',
                        logindate: new Date().toISOString().slice(0, 10),
                        admin: info.admin ?? '',
                        userPhoneNum: info.userPhoneNum ?? '',
                        userSendOtpType: info.userSendOtpType ?? '',
                        deptName: info.deptName ?? '',
                        kindName: info.kindName ?? '',
                        userRole: info.userRole ?? ''
                    };                    
                    if (data.status == 'Already Session Exists') {
                        if (window.confirm("다른 브라우저에 로그인된 계정입니다. 로그인할 경우 기존 연결은 끊깁니다. 계속 하시겠습니까?") == true) {
                            userInfo["delSession"] = true;
                            doLogin(userInfo);
                            return;
                        } else {
                            return;
                        }
                    } else {
                        const cookieResponse = await fetch('api/Login/SetCookie', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=utf-8'
                            },
                            credentials: 'include',
                            body: JSON.stringify({
                                userId: info.userId,
                                sessionId: info.sessionID,
                                isAutoLogin: isAutoLogin
                            })
                        });
                        if (!cookieResponse.ok) {
                            showToast('danger', '로그인 인증 쿠키 발급에 실패했습니다.', 3000);
                            return;
                        }
                        await LoginActions.setResultLogin(result);
                        props.setMessage(data.message);
                        props.setResult(data.status);
                        props.setPanelType('');
                    }
                    localStorage.setItem("isAutoLogin", JSON.stringify({ isAutoLogin: isAutoLogin, userId: info.userId }));
                    getManualViewHistory(info.userId);
                }
            });
    };
    const getManualViewHistory = (userId) => {
        const body = {
            devUserId: userId
        };
        fetch(`api/Document/GetManualViewHistory`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === "Success" && resultData.data.table.length > 0) {
                    let transformedData = transformTagsToArray(resultData.data.table);
                    transformedData = [...transformedData].reverse();
                    localStorage.setItem("manualHistory", JSON.stringify(transformedData));
                }
            });
    };
    const transformTagsToArray = (data) => {
        return data.map((item) => ({
            ...item,
            tag: JSON.parse(item.tag),
            fullPath: JSON.parse(item.fullPath)
        }));
    };
    const cookieLogin = (otpAuthCode) => {
        fetch('api/Login/CookieLogin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                authCode: otpAuthCode,
                validTime: 30
            })
        }).then((response) => response.json())
            .then(async (data) => {
                const info = data.userInformation;
                if (data.status != 'Success Login' && data.status != 'Already Session Exists' && data.status != 'Change Password') {
                    showToast('danger', data.message, 3000);
                } else {
                    const result = {
                        userId: info.userId ?? '',
                        userName: info.userName ?? '',
                        sessionId: info.sessionID ?? '',
                        companyName: info.companyName ?? '',
                        companySeq: info.companySeq ?? '',
                        companyType: info.companyType ?? '',
                        devType: info.devType ?? '',
                        logindate: new Date().toISOString().slice(0, 10),
                        admin: info.admin ?? '',
                        userPhoneNum: info.userPhoneNum ?? '',
                        userSendOtpType: info.userSendOtpType ?? '',
                        deptName: info.deptName ?? '',
                        kindName: info.kindName ?? '',
                        userRole: info.userRole ?? ''
                    };                    
                    if (data.status == 'Already Session Exists') {
                        if (window.confirm("다른 브라우저에 로그인된 계정입니다. 로그인할 경우 기존 연결은 끊깁니다. 계속 하시겠습니까?") == true) {
                            userInfo["delSession"] = true;
                            doLogin(userInfo);
                            return;
                        } else {
                            return;
                        }
                    } else {
                        await LoginActions.setResultLogin(result);
                        window.sessionStorage.removeItem('kdcCookieOtpRequestedAt');
                        props.setMessage(data.message);
                        props.setResult(data.status);
                        props.setPanelType('');
                    }
                    getManualViewHistory(info.userId);
                }
            });
    };
    const onCancel = (e) => {
        e.preventDefault();
        localStorage.removeItem("isAutoLogin");
        history('/');
    }

    const FindPassword = () => {
        props.setPanelType('findPassword');
    };

    const AfterCheckAuth = (authCode) => {
        if (location.state?.loginType === 'cookie') {
            cookieLogin(authCode);
            return;
        }
        setIsVerify(true);
        setAuthCode(authCode);
    };

    const otpItems = {
        '0': {ico: "ico-mail", txt: '이메일'},
        '1': {ico: "ico-mail", txt: '이메일'},
        '2': {ico: "ico-kakao", txt: '카카오톡'},
        '3': {ico: "ico-msg", txt: 'SMS'}
    }

    return (
        <div className="login-wrap">
            {openOTP ?
                <form className="login-box">
                    <div className="login-top">
                        <h2 className='login-title'>2차 인증</h2>
                        <div className="login-input-wrap">
                            <div className='auth-msg'>
                                <i className={`icoKdc32 ${otpItems[otpType].ico}`}></i>
                                <p className='auth-txt'>{otpItems[otpType].txt}에서 2차 인증을 완료해 주세요.</p>
                            </div>
                            <OTPVerificationPanel otpType={otpType} state={userInfo} fnAfterCheckAuth={AfterCheckAuth} authAlreadySent deferVerification={location.state?.loginType === 'cookie'} />
                        </div>
                    </div>
                    {/* <div className="btn-wrap">
                        <button onClick={(e) => onCancel(e)} className={`btn-login`} name='Cancel'>취소</button>
                    </div> */}
                </form>
                : 
                <form className="login-box">
                    <div className="login-top">
                        <h2 className='login-title'>로그인</h2>
                        <div className="login-input-wrap">
                            <div className="login-input">
                                <label htmlFor="userID">아이디</label>
                                <input type='text' name='userId' placeholder='아이디' value={userInfo.userId ?? ''} onChange={e => handleChange(e)} />
                            </div>
                            <div className="login-input">
                                <label htmlFor="userPassword">비밀번호</label>
                                <input type='password' name='userPassword' placeholder='비밀번호' value={userInfo.userPassword ?? ''} onChange={e => handleChange(e)} />
                            </div>
                            <label class="login-opt">
                                <input type="checkbox" onChange={() => setIsAutoLogin(prev => !prev)} checked={isAutoLogin} />
                                <span class="label-text">자동 로그인</span>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div className="btn-wrap">
                        <button onClick={(e) => onSubmit(e)} className={`btn-login ${openOTP ? "dis" : ""}`} name='Login'>로그인</button>
                        <div className="btn-txt-wrap">
                            <a onClick={FindPassword} className="btn-txt">비밀번호 재설정</a>
                            <a onClick={(e) => onSubmitSignUp(e)} className="btn-txt">회원가입</a>
                        </div>
                        {/* <button onClick={(e) => onSubmitSignUp(e)} className='btn-primary-t2'>K Developers에 가입하세요</button> */}
                    </div>
                </form>
            }
        </div>
    );
};

export default LoginPanel;
